import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js'
import { getApplications, getPersonAttachments, deletePersonAttachments } from '../../Api/UserActions.js'
import { getJsonItem, getDateString, getJsonDate } from '../../Utilities/JsonFunctions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'
import FormSelect from '../../Fields/FormSelect.js';
import NamezzzUploads from '../../Fields/NamezzzUploads.js';
import Reloading from '../Reloading.js';

declare var globalSns;

class AllUploads extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobId: -1
        };

        this.loadData = this.loadData.bind(this);
        this.onJobChanged = this.onJobChanged.bind(this);
        this.showValidation = this.showValidation.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getPersonAttachments(globalSns.languageId, 0, (data) => {
            this.setState({
                personAttachments: data
            });
            this.setState({
                reloading: false
            });
        });
        if (this.state.applications == null) { // reloading application is not needed
            getApplications(globalSns.languageId, (data) => {
                this.setState({
                    applications: data
                });
            });
        }
    }

    reloadData = () => {
        this.setState({
            reloading: true
        });
        this.loadData();
    }

    onPersonAttachmentDelete(id, historyId, e) {
        deletePersonAttachments(id, historyId, () => {
            var item = getJsonItem(this.state.personAttachments, "id", id);
            var index = this.state.personAttachments.indexOf(item);

            this.setState({
                personAttachments: update(this.state.personAttachments, {$splice: [[index, 1]]})
            })
        });
    }

    onJobChanged(e) {
        this.setState({
            [e.target.id] : parseInt(e.target.value, 10)
        }); 
    }

    showValidation() {
        this.setState({
            showValidation: true
        });
    }

    render() {
        // Check loading state
        if (this.state.personAttachments == null || this.state.applications == null) {
            return (
                <Loading/>
            );
        }

        // Attachment data
        let attachGeneral = this.state.personAttachments.filter(function (personAttachment) {
            return personAttachment.jobId == null;
        });
      
        let attachSpecific = this.state.personAttachments.filter(function (personAttachment) {
            return personAttachment.jobId != null;
        });

        // Application data
        let applications = [];
        let hasJob0 = false;
        let selectedJobId = this.state.jobId;

        for (let iJob = 0; iJob < this.state.applications.length; iJob++) {
            let application = this.state.applications[iJob];
            hasJob0 = hasJob0 || application.jobId === 0;
            if (application.isClosed || application.jobId === 0) {
                continue; // only upload to open applications
            }

            let itemJob = { key: application.jobId, value: application.name }
            applications.push(itemJob);
        }

        let showApplications = !(applications.length === 0 || (!hasJob0 && applications.length === 1));

        if (showApplications) {
            applications.unshift({key: 0, value: getTranslation("sns.webparts.alluploads.general")});
        } else {
            selectedJobId = applications.length === 0 ? 0 : applications[0].key;
        }

        return (
            <div className="registration">
                <div className="EditingFormTable table">
                    {
                        (this.state.personAttachments.length > 0) ?
                            <div className="tr table-wrapper userdata">
                                <strong>{getTranslation("sns.webparts.uploads.documents")}</strong>
                                <table className="table table-condensed table-responsive">
                                    <tbody>
                                        <tr>
                                            <td colSpan="4" className="text-center"><label>{getTranslation("sns.webparts.alluploads.general")}</label></td>
                                        </tr>
                                        {
                                            attachGeneral.map((personAttachment) => 
                                                <tr key={personAttachment.id}>
                                                    <td>{getDateString(getJsonDate(personAttachment.creDat))}</td>
                                                    <td>{personAttachment.category}</td>
                                                    <td><a href={personAttachment.url} target="_blank">{personAttachment.name}</a></td>
                                                    <td><a href="# " className="file" onClick={(e) => this.onPersonAttachmentDelete(personAttachment.id, personAttachment.historyId, e)}><span className="sr-only">{getTranslation("sns.general.screenreader.delete")}</span><i className="fa fa-trash-o" aria-hidden="true"></i></a></td>
                                                </tr>
                                            )
                                        }
                                        {
                                            attachSpecific.group(item => item.job).map((jobUploads) => {

                                                var childRows = jobUploads.data.map((personAttachment) => 
                                                    <tr key={personAttachment.id}>
                                                        <td>{getDateString(getJsonDate(personAttachment.creDat))}</td>
                                                        <td>{personAttachment.category}</td>
                                                        <td><a href={personAttachment.url} target="_blank">{personAttachment.name}</a></td>
                                                        <td><a href="# " className="file" onClick={(e) => this.onPersonAttachmentDelete(personAttachment.id, personAttachment.historyId, e)}><span className="sr-only">{getTranslation("sns.general.screenreader.delete")}</span><i className="fa fa-trash-o" aria-hidden="true"></i></a></td>
                                                    </tr>
                                                );

                                                return [
                                                    <tr key={jobUploads.key}>
                                                        <td colSpan="4" className="text-center"><label>{jobUploads.key}</label></td>                                               
                                                    </tr>,
                                                    childRows  
                                                ];
                                            })
                                        }                                           
                                    </tbody>
                                </table>
                            </div> :
                            ""
                    }
                    {
                        this.state.reloading ? (<Reloading />) : ""
                    }
                    {
                        showApplications ?  
                            <FormSelect id="jobId"
                            text={getTranslation("sns.webparts.uploads.job")}
                            required={true}
                            showValidation={this.state.showValidation}
                            validationText={selectedJobId === -1 ? getTranslation("basicform.erroremptyvalue"): null}
                            emptyValue={getTranslation("sns.general.ddlnovalue")}
                            data={applications}
                            value={selectedJobId}
                            onChange={this.onJobChanged} /> : 
                        ""
                    }
                    <NamezzzUploads jobId={selectedJobId} onFileUploadsSaved={this.reloadData} onNoJobIdSelected={this.showValidation} />
                </div>
            </div>
        );
    }
}
                                 
export default AllUploads;


// WEBPACK FOOTER //
// ./src/Components/Pages/AllUploads.js